// @flow
import React from "react";

import Selector from '../index';
import type { Props } from '../index'
import { useFamilles } from 'redux/hooks'


export default ({ value, onChange, ...props }: Props) => {

    const data = useFamilles();

    return (
        <Selector
            {...props}
            label="Sélection des familles"
            value={value}
            onChange={onChange}
            data={data}
        />
    )
};